import { render, staticRenderFns } from "./App.vue?vue&type=template&id=03d3f1b0&scoped=true"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=03d3f1b0&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d3f1b0",
  null
  
)

export default component.exports